"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var VueLodash={install:function(e,t){e._=t,Object.defineProperties(e.prototype,{_:{get:function(){return t}}}),e.mixin({mounted:function(){}}),"undefined"!=typeof window&&window.Vue&&window.Vue.use(VueLodash)}};exports.default=VueLodash;


//////////////////
// WEBPACK FOOTER
// ./~/vue-lodash/dist/vue-lodash.min.js
// module id = 86
// module chunks = 0